import type { ReactNode } from 'react';

import { Sidebar } from '../components/desktop';
import {
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_COLLAPSED,
} from '../constants/dashboard.constants';
import { SidebarCollapseProvider } from '../hooks/SidebarCollapseContext';
import { useSidebarCollapse } from '../hooks/useSidebarCollapse';

interface DesktopLayoutProps {
  children: ReactNode;
}

function DesktopLayoutContent({ children }: DesktopLayoutProps) {
  const { isCollapsed } = useSidebarCollapse();
  const marginLeft = isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH;

  return (
    <div className="min-h-screen bg-surface-primary">
      <Sidebar />
      <div
        className="flex min-h-screen flex-col transition-all duration-300 ease-in-out"
        style={{ marginLeft }}
      >
        <main className="flex-1 bg-surface-primary">
          <div className="p-10">{children}</div>
        </main>
      </div>
    </div>
  );
}

export function DesktopLayout({ children }: DesktopLayoutProps) {
  return (
    <SidebarCollapseProvider>
      <DesktopLayoutContent>{children}</DesktopLayoutContent>
    </SidebarCollapseProvider>
  );
}
